import * as Three from 'three';
import React from 'react';

export default {
    name: 'void',
    prototype: 'items',

    info: {
        tag: [''],
        title: 'Void',
        description: 'Void',
        image: require('./void.PNG')
    },

    properties: {
        // altitude: {
        //     label: 'altitude',
        //     type: 'length-measure',
        //     defaultValue: {
        //         length: 0,
        //         unit: 'cm'
        //     }
        // },
        width: {
            label: 'width',
            type: 'length-measure',
            defaultValue: {
                length: 60,
                unit: 'cm'
            }
        },
        depth: {
            label: 'depth',
            type: 'length-measure',
            defaultValue: {
                length: 60,
                unit: 'cm'
            }
        }
    },

    render2D: function (element, layer, scene) {
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" };
        let width = element.properties.get('width').get('length');
        let depth = element.properties.get('depth').get('length');
        return (
            <g transform={`translate(${-width / 2},${-depth / 2})`}>
                <rect key="1" x='0' y='0' width={width} height={depth} style={style} />
                <line key="2" x1={0} y1={0} x2={width} y2={depth} stroke={element.selected ? '#000' : '#777'} strokeWidth="2" />
                <line key="3" x1={width} y1={0} x2={0} y2={depth} stroke={element.selected ? '#000' : '#777'} strokeWidth="2" />
            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    }
};
